export default '/pricing/spam-blocker';
